import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { trackAndNavigate } from '../utils/metaPixel';
import { offerItems } from '../data/landing';
export const CHECKOUT_URL = 'https://megapackcontabilidad.impultienda.ar/checkout';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="bg-stone-50" data-id="element-129" data-mp="ddvf7d322bdi">
      <div className="mx-auto max-w-2xl bg-white px-5 py-20 lg:py-24" data-id="element-130" data-mp="dfygit9nrqxj">
        <h2 id="oferta-title" className="text-center font-serif text-3xl font-black leading-[1.1] text-stone-900 sm:text-4xl" data-id="element-131" data-mp="icowlglgqmiy">
          <span aria-hidden="true" data-id="element-132" data-mp="mgo8flvssx5z">🏆 </span>Todo tu MegaPack en una sola compra
        </h2>

        <div className="relative mt-12 rounded-3xl border-2 border-brand px-4 pb-8 pt-12 sm:px-10 sm:pb-9" data-id="element-133" data-mp="rc3ie2qoq8x4">
          <span className="absolute -top-[0.85rem] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-134" data-mp="2t59inaxtfelv">
            MegaPack Contabilidad Lista
          </span>

          <ul className="space-y-3.5" data-id="element-135" data-mp="12oa96x90wbka">
            {offerItems.map(item => <li key={item} className="flex gap-3" data-id="element-136" data-mp="xx1xfuk80e3y">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-137" data-mp="xvh2w4xwov63" />
                <span className="text-[15px] leading-snug text-stone-700" data-id="element-138" data-mp="sy8mo9wbj17h">{item}</span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-3 border-t border-stone-200 pt-8 text-center" data-id="element-139" data-mp="ou0vm62e1963">
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-stone-600" data-id="element-140" data-mp="1gn9x22opomfe">Precio del pack completo</span>
            <p className="font-serif text-5xl font-black leading-none text-brand sm:text-6xl" data-id="element-141" data-mp="1cl6hb1v0evob">
              $19.990 <span className="font-sans text-lg font-bold text-stone-900 sm:text-xl" data-id="element-142" data-mp="17neg1h8h5x7g">ARS</span>
            </p>
          </div>

          <p className="mt-8 border-t border-stone-200 pt-6 text-center text-sm text-stone-600" data-id="element-143" data-mp="17avxbdihqon">
            <span aria-hidden="true" data-id="element-144" data-mp="3sc119ekh12gj">💳 </span>Pago único.
          </p>

          <a href={CHECKOUT_URL} onClick={event => trackAndNavigate(event, CHECKOUT_URL, 'InitiateCheckout', {
          content_name: 'MegaPack Contabilidad Lista',
          content_ids: ['megapack-contabilidad-lista'],
          content_type: 'product',
          value: 19990,
          currency: 'ARS'
        })} className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-brand px-5 py-4 text-center text-[12px] font-bold uppercase leading-tight tracking-[0.08em] text-white shadow-lg shadow-brand/30 transition-[transform,background-color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-0.5 hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-stone-900 sm:gap-3 sm:px-8 sm:py-5 sm:text-sm sm:tracking-[0.1em]" data-id="element-145" data-mp="3ttq0kgxclzge">
            Quiero los 10 tomos + los 5 bonos
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" aria-hidden="true" data-id="element-146" data-mp="2x3qq2gxn0qv6" />
          </a>

          <p className="mt-6 text-center text-xs text-stone-600" data-id="element-147" data-mp="2djrw2l153bu3">
            Descarga digital · Acceso inmediato · Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}